<loader *ngIf="loading"></loader>
<div class="intake-party-failed" *ngIf="loadFailed && !data">
  <p>{{ "translate.intakeParty.loadFailed" | translate }}</p>
  <button type="button" class="t-button-outline intake-party-retry" (click)="load()">{{ "translate.intakeParty.retry" | translate }}</button>
</div>
<div class="intake-party" *ngIf="data">
  <header class="intake-party-head">
    <div class="intake-party-titleRow">
      <h2 class="intake-party-title">{{ (duplicatesOnly ? "translate.intakeParty.duplicatesTitle" : "translate.intakeParty.title") | translate }}</h2>
      <ol *ngIf="twoSteps" class="intake-party-steps">
        <li [class.is-on]="step === 'clinic'" [class.is-done]="step === 'dentist'">
          <span class="intake-party-stepNo" aria-hidden="true">
            <i *ngIf="step === 'dentist'; else stepOne" class="fas fa-check"></i>
            <ng-template #stepOne>1</ng-template>
          </span>
          {{ "translate.intakeParty.stepClinic" | translate }}
        </li>
        <li [class.is-on]="step === 'dentist'">
          <span class="intake-party-stepNo" aria-hidden="true">2</span>
          {{ "translate.intakeParty.stepDentist" | translate }}
        </li>
      </ol>
    </div>

    <!-- what the case itself says, to choose by -->
    <dl class="intake-party-context">
      <div *ngIf="patientName" class="intake-party-patient">
        <dt>{{ "translate.intakeParty.patient" | translate }}</dt>
        <dd>{{ patientName }}</dd>
      </div>
      <div class="intake-party-scan">
        <dt>{{ "translate.intakeParty.inScan" | translate }}</dt>
        <dd *ngIf="step === 'clinic'">
          <b>{{ data.scan.practiceName }}</b>
          <span *ngIf="data.scan.address || data.scan.city" class="intake-party-muted">
            {{ data.scan.address }}<ng-container *ngIf="data.scan.address && data.scan.city">, </ng-container>{{ data.scan.city }}
          </span>
        </dd>
        <dd *ngIf="step === 'dentist'">
          <b>{{ data.scan.dentistName }}</b>
          <span *ngIf="data.scan.dentistEmail" class="intake-party-muted" dir="ltr">{{ data.scan.dentistEmail }}</span>
        </dd>
        <dd *ngIf="step === 'duplicates'">
          <b>{{ data.scan.practiceName }}</b>
          <span *ngIf="data.scan.dentistName" class="intake-party-muted">{{ data.scan.dentistName }}</span>
        </dd>
      </div>
    </dl>
  </header>

  <div class="intake-party-body">
    <!-- before step 1: orders of the lab this case may be -->
    <section *ngIf="step === 'duplicates'" class="intake-party-step intake-party-duplicates-step">
      <h3 *ngIf="!duplicatesOnly" class="intake-party-duplicates-title">{{ "translate.intakeParty.duplicatesTitle" | translate }}</h3>
      <p class="intake-party-muted intake-party-caption">{{ "translate.intakeParty.duplicatesCaption" | translate }}</p>
      <div class="intake-party-list">
        <!-- in the list, so its columns get the rows' width, scrollbar or not -->
        <div class="intake-party-dup-grid intake-party-colhead" aria-hidden="true">
          <span>{{ "translate.intakeParty.order" | translate }}</span>
          <span>{{ "translate.intakeParty.patient" | translate }}</span>
          <span>{{ "translate.intakeParty.stepClinic" | translate }}</span>
          <span>{{ "translate.intakeParty.stepDentist" | translate }}</span>
          <span>{{ "translate.intakeParty.orderDate" | translate }}</span>
          <span></span>
        </div>
        <div *ngFor="let dup of data.duplicates" class="intake-party-row intake-party-dup-grid intake-party-duplicate-row">
          <span class="intake-party-dup-order">
            <bdi class="intake-party-name">{{ dup.displayId }}</bdi>
            <span *ngIf="showMeimad(dup)" class="intake-party-muted intake-party-dup-meimad">
              {{ "translate.intakeParty.meimad" | translate }} <bdi>{{ dup.orderIdMmd }}</bdi>
            </span>
          </span>
          <span class="intake-party-dup-patient">
            <span class="intake-party-name">{{ dup.patientName }}</span>
            <span class="intake-party-chip" [class.is-same]="dup.sameName">
              {{ (dup.sameName ? "translate.intakeParty.sameName" : "translate.intakeParty.similar") | translate }}
            </span>
          </span>
          <span class="intake-party-muted">{{ dup.clinicDescr }}</span>
          <span class="intake-party-muted">{{ dup.doctorName }}</span>
          <span class="intake-party-muted">{{ dup.orderDate | date: "dd/MM/yy" }}</span>
          <button type="button" class="t-button-outline warn intake-party-merge" [disabled]="busy || merging" (click)="merge(dup)">
            {{ "translate.intakeParty.merge" | translate }}
          </button>
        </div>
      </div>
    </section>

    <!-- step 1: the clinic -->
    <section *ngIf="step === 'clinic'" class="intake-party-step intake-party-clinic-step">
      <div class="intake-party-tabs" role="tablist">
        <button type="button" role="tab" class="intake-party-tab tab-existing" [class.is-active]="clinicTab === 'existing'" [attr.aria-selected]="clinicTab === 'existing'" (click)="setClinicTab('existing')">
          {{ "translate.intakeParty.existingClinic" | translate }}
        </button>
        <button type="button" role="tab" class="intake-party-tab tab-shila" [class.is-active]="clinicTab === 'shila'" [attr.aria-selected]="clinicTab === 'shila'" (click)="setClinicTab('shila')">
          {{ "translate.intakeParty.shilaByPo" | translate }}
        </button>
        <button type="button" role="tab" class="intake-party-tab tab-new" [class.is-active]="clinicTab === 'new'" [attr.aria-selected]="clinicTab === 'new'" (click)="setClinicTab('new')">
          {{ "translate.intakeParty.newClinic" | translate }}
        </button>
      </div>

      <ng-container *ngIf="clinicTab === 'existing'">
        <ng-container *ngTemplateOutlet="search; context: { $implicit: 'translate.intakeParty.searchClinic' }"></ng-container>
        <div class="intake-party-list">
          <button
            *ngFor="let clinic of clinics | slice: 0 : limit"
            type="button"
            class="intake-party-row intake-party-clinic-row"
            [class.is-selected]="pickedClinicId === clinic.clinicId"
            [class.is-similar]="clinic.similar"
            (click)="pickedClinicId = clinic.clinicId"
          >
            <span class="intake-party-name">{{ clinic.clinicDescr }}</span>
            <span *ngIf="clinic.similar" class="intake-party-chip">{{ "translate.intakeParty.similar" | translate }}</span>
            <span *ngIf="clinic.address || clinic.city" class="intake-party-muted intake-party-rowEnd">{{ clinic.address }} {{ clinic.city }}</span>
          </button>
          <p *ngIf="!clinics.length" class="intake-party-empty">{{ "translate.intakeParty.noMatch" | translate }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="clinicTab === 'shila'">
        <ng-container *ngTemplateOutlet="search; context: { $implicit: 'translate.intakeParty.search' }"></ng-container>
        <p class="intake-party-muted intake-party-caption">{{ "translate.intakeParty.shilaCaption" | translate }}</p>
        <loader *ngIf="loadingShila"></loader>
        <div class="intake-party-list">
          <!-- in the list, so its columns get the rows' width, scrollbar or not -->
          <div *ngIf="shilaPos.length" class="intake-party-po-grid intake-party-colhead" aria-hidden="true">
            <span>{{ "translate.shilaPo.poNumber" | translate }}</span>
            <span>{{ "translate.shilaPo.patient" | translate }}</span>
            <span>{{ "translate.intakeParty.branch" | translate }}</span>
            <span>{{ "translate.shilaPo.doctor" | translate }}</span>
          </div>
          <button
            *ngFor="let po of shilaPos | slice: 0 : limit"
            type="button"
            class="intake-party-row intake-party-po-grid intake-party-po-row"
            [class.is-selected]="pickedPo?.poNumber === po.poNumber"
            (click)="pickPo(po)"
          >
            <span class="intake-party-po-number"><bdi dir="ltr">{{ po.poNumber }}</bdi></span>
            <span class="intake-party-name">{{ po.patientName }} <span class="intake-party-muted">({{ po.patientFileNo }})</span></span>
            <span class="intake-party-muted">{{ po.clinicName }}</span>
            <span class="intake-party-muted">{{ po.doctorName }}</span>
          </button>
          <p *ngIf="shila && !shilaPos.length" class="intake-party-empty">{{ "translate.intakeParty.noMatch" | translate }}</p>
        </div>

        <div *ngIf="pickedPo" class="intake-party-branchBox">
          <p *ngIf="pickedPo.clinicId" class="intake-party-po-known">
            <i class="fas fa-check-circle" aria-hidden="true"></i>
            {{ "translate.intakeParty.branchClinic" | translate: { name: pickedPo.clinicName } }}
          </p>
          <ng-container *ngIf="!pickedPo.clinicId">
            <h4 class="intake-party-group">{{ "translate.intakeParty.branchUnknown" | translate: { name: pickedPo.clinicName } }}</h4>
            <div class="intake-party-branch">
              <button
                *ngFor="let c of shila.shilaClinics"
                type="button"
                class="intake-party-branch-row"
                [class.is-selected]="branch === c.clinicId"
                (click)="branch = c.clinicId"
              >
                <span class="intake-party-radio" aria-hidden="true"></span>
                <span *ngIf="pickedPo.likelyClinicIds.includes(c.clinicId); else plainClinic">
                  {{ "translate.intakeParty.likelyClinic" | translate: { name: c.clinicDescr, code: pickedPo.shilaClinicCode } }}
                </span>
                <ng-template #plainClinic>
                  <span>{{ c.clinicDescr }}</span>
                </ng-template>
              </button>
              <button type="button" class="intake-party-branch-row branch-new" [class.is-selected]="branch === 'NEW'" (click)="branch = 'NEW'">
                <span class="intake-party-radio" aria-hidden="true"></span>
                <span>{{ "translate.intakeParty.newBranch" | translate }}</span>
              </button>
            </div>
            <p class="intake-party-note intake-party-branch-note">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
              {{
                (branch === "NEW" ? "translate.intakeParty.newBranchNote" : "translate.intakeParty.branchCodeNote")
                  | translate: { name: pickedPo.clinicName }
              }}
            </p>
          </ng-container>
        </div>
      </ng-container>

      <div *ngIf="clinicTab === 'new'" class="intake-party-form intake-party-clinic-form">
        <label class="is-wide">
          <span>{{ "translate.intakeParty.name" | translate }} <span class="intake-party-req">*</span></span>
          <input class="t-input t-input--colored intake-party-clinic-name" maxlength="80" [(ngModel)]="newClinic.name" />
        </label>
        <label>
          <span>{{ "translate.intakeParty.address" | translate }}</span>
          <input class="t-input t-input--colored intake-party-clinic-address" maxlength="255" [(ngModel)]="newClinic.address" />
        </label>
        <label>
          <span>{{ "translate.intakeParty.city" | translate }}</span>
          <input class="t-input t-input--colored intake-party-clinic-city" maxlength="50" [(ngModel)]="newClinic.city" />
        </label>
        <label>
          <span>{{ "translate.intakeParty.phone" | translate }}</span>
          <input class="t-input t-input--colored intake-party-clinic-phone" maxlength="14" dir="ltr" [(ngModel)]="newClinic.phone" />
        </label>
        <p class="intake-party-note is-wide">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
          {{ "translate.intakeParty.newClinicNote" | translate }}
        </p>
      </div>
    </section>

    <!-- step 2: the dentist -->
    <section *ngIf="step === 'dentist'" class="intake-party-step intake-party-dentist-step">
      <div class="intake-party-tabs" role="tablist">
        <button type="button" role="tab" class="intake-party-tab tab-existing-dentist" [class.is-active]="dentistTab === 'existing'" [attr.aria-selected]="dentistTab === 'existing'" (click)="setDentistTab('existing')">
          {{ "translate.intakeParty.existingDentist" | translate }}
        </button>
        <button type="button" role="tab" class="intake-party-tab tab-new-dentist" [class.is-active]="dentistTab === 'new'" [attr.aria-selected]="dentistTab === 'new'" (click)="setDentistTab('new')">
          {{ "translate.intakeParty.newDentist" | translate }}
        </button>
        <button type="button" role="tab" class="intake-party-tab tab-no-dentist" [class.is-active]="dentistTab === 'none'" [attr.aria-selected]="dentistTab === 'none'" (click)="setDentistTab('none')">
          {{ "translate.intakeParty.noDentist" | translate }}
        </button>
      </div>

      <ng-container *ngIf="dentistTab === 'existing'">
        <ng-container *ngTemplateOutlet="search; context: { $implicit: 'translate.intakeParty.searchDentist' }"></ng-container>
        <div class="intake-party-list">
          <ng-container *ngFor="let group of [groups.atClinic, groups.others]; let i = index">
            <h4 *ngIf="group.length" class="intake-party-group">
              {{ (i === 0 ? "translate.intakeParty.atClinic" : "translate.intakeParty.otherDentists") | translate }}
            </h4>
            <button
              *ngFor="let dentist of group | slice: 0 : limit"
              type="button"
              class="intake-party-row intake-party-dentist-row"
              [class.is-selected]="pickedDoctorId === dentist.doctorId"
              [class.is-similar]="dentist.similar"
              (click)="pickedDoctorId = dentist.doctorId"
            >
              <span class="intake-party-name">{{ dentist.wholeName }}</span>
              <span *ngIf="dentist.similar" class="intake-party-chip">{{ "translate.intakeParty.similar" | translate }}</span>
            </button>
          </ng-container>
          <p *ngIf="!groups.atClinic.length && !groups.others.length" class="intake-party-empty">
            {{ "translate.intakeParty.noMatch" | translate }}
          </p>
        </div>
      </ng-container>

      <div *ngIf="dentistTab === 'new'" class="intake-party-form intake-party-dentist-form">
        <label>
          <span>{{ "translate.intakeParty.fullName" | translate }} <span class="intake-party-req">*</span></span>
          <input class="t-input t-input--colored intake-party-dentist-name" maxlength="100" [(ngModel)]="newDentist.wholeName" />
        </label>
        <label>
          <span>{{ "translate.intakeParty.phone" | translate }}</span>
          <input class="t-input t-input--colored intake-party-dentist-phone" maxlength="14" dir="ltr" [(ngModel)]="newDentist.phone" />
        </label>
        <p class="intake-party-note is-wide">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
          {{ "translate.intakeParty.newDentistNote" | translate }}
        </p>
      </div>

      <p *ngIf="dentistTab === 'none'" class="intake-party-note intake-party-no-dentist-note">
        <i class="fas fa-info-circle" aria-hidden="true"></i>
        {{ "translate.intakeParty.noDentistNote" | translate }}
      </p>
    </section>
  </div>

  <footer class="intake-party-foot">
    <span *ngIf="showRemember" class="intake-party-remember">
      {{ "translate.intakeParty.remember" | translate }}
    </span>
    <button *ngIf="step === 'duplicates'; else saveButton" type="button" class="t-button--success intake-party-continue" [disabled]="busy || merging" (click)="passDuplicates()">
      {{ "translate.intakeParty.notDuplicate" | translate }}
    </button>
    <ng-template #saveButton>
      <button type="button" class="t-button--success intake-party-save" [disabled]="!canSave" (click)="save()">
        {{ saveLabel | translate }}
      </button>
    </ng-template>
  </footer>
</div>

<ng-template #search let-placeholder>
  <div class="intake-party-searchBox">
    <i class="fas fa-search" aria-hidden="true"></i>
    <input
      class="t-input t-input--colored intake-party-search"
      [ngModel]="filter"
      (ngModelChange)="setFilter($event)"
      [placeholder]="placeholder | translate"
      [attr.aria-label]="placeholder | translate"
    />
  </div>
</ng-template>
